export const DEFAULT_PER_PAGE = 10;
export const DEFAULT_INPUT_MAX_LENGTH = 120;
